import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Carousel from '@nerdwallet/react-carousel';
import classNames from 'classnames';

import { CenteredContainer, Title, Text } from '@nerdwallet/currency';

import OurValuesModuleTile from './our-values-tile';

import styles from './our-values.module.less';

import dataDesktop from './our-values-content';
import dataMobile from './our-values-content-mobile';

import { stringSelectSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const OurValuesModule = ({ size, titleInGotham, titleSize, showHeading }) => {
  const isMobile = size === 'sm' || size === 'md';
  let data = dataDesktop;
  if (isMobile) {
    data = dataMobile;
  }

  const renderedTiles = _.map(data.tiles, (tile, id) => (
    <OurValuesModuleTile {...tile} key={id} isMobile={isMobile} />
  ));

  return (
    <React.Fragment>
      {showHeading && (
        <CenteredContainer>
          <Title
            size={titleSize}
            className={classNames([
              styles.titleContainer,
              {
                [styles.titleInGotham]: titleInGotham,
              },
            ])}
            component="h2"
          >
            Our values
          </Title>
          <div className={styles.descriptionContainer}>
            <Text>
              Our values shape everything we do. They&#39;re not just words
              written on a wall, but lived and breathed every day by every Nerd.
            </Text>
          </div>
        </CenteredContainer>
      )}
      <CenteredContainer className={styles.valuesContainer}>
        <Carousel
          autoplay={false}
          allowLooping
          decorateNav={false}
          enableDotNavigation
          inactiveDotColor="#000000"
          activeDotColor="#008255"
          className={styles.valuesCarousel}
        >
          {renderedTiles}
        </Carousel>
        <div className={styles.valuesSmorga}>{renderedTiles}</div>
      </CenteredContainer>
    </React.Fragment>
  );
};

OurValuesModule.propTypes = {
  size: PropTypes.string,
  titleInGotham: PropTypes.string,
  titleSize: PropTypes.string,
  showHeading: PropTypes.bool,
};

OurValuesModule.defaultProps = {
  titleSize: 'small',
  showHeading: false,
};

OurValuesModule.getEditingConfig = (componentDocument) => {
  const showHeadingConfig = componentDocument?.props?.showHeading
    ? [
        boolCheckboxSpec(
          'titleInGotham',
          'Display title in Gotham instead of Chronicle?'
        ),
        stringSelectSpec('titleSize', 'Title Size', [
          { label: 'Small', value: 'small' },
          { label: 'Large', value: 'default' },
        ]),
      ]
    : [];
  return [
    boolCheckboxSpec('showHeading', 'Display Our Values heading?'),
    ...showHeadingConfig,
  ];
};

export default connect(
  createStructuredSelector({
    size: property('mediaQuery'),
  })
)(OurValuesModule);
